import { useState } from 'react';
import { useCustomEvent } from '../../hooks/useCustomEvent';
import { Wrapper } from './Time.style';
import { lz } from './Time.utils';

export type TimeProps = {};

export function Time(_props: TimeProps) {
  const [time, setTime] = useState(0);

  useCustomEvent('MUSIC_TIME', (data: Json) => {
    const { ts } = data;
    setTime(Math.round(ts));
  });

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  return (
    <Wrapper className='Time-wrapper' data-testid='Time-wrapper'>
      {lz(minutes)}:{lz(seconds)}
    </Wrapper>
  );
}

export default Time;
